module.exports = __webpack_public_path__ + "0bd0100e14c0ccd1bee1049e910b8b00.jpg";


//////////////////
// WEBPACK FOOTER
// ./img/mobile/m-index-img1.jpg
// module id = 225
// module chunks = 3